module.exports = {
  "container": {
    "backgroundColor": "#dddddd",
    "borderTopWidth": "1",
    "borderTopColor": "#dddddd"
  },
  "border": {
    "borderBottomWidth": "1",
    "borderBottomColor": "#dddddd"
  },
  "wxc-skid": {
    "flexDirection": "row",
    "backgroundColor": "#FFFFFF"
  },
  "swipe-action-right": {
    "flexDirection": "row",
    "alignItems": "center"
  },
  "swipe-action-center": {
    "width": "750"
  },
  "swipe-action-child": {
    "width": "100",
    "textAlign": "center",
    "color": "#FFFFFF",
    "backgroundColor": "#dddddd",
    "lineHeight": "90"
  },
  "swipe-action-text": {
    "fontSize": "30"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-c855898a!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/wxc-swipe-action/index.vue
// module id = 193
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34